export const SAVE_TAKE_PAYMENT_DETAILS = 'SAVE_TAKE_PAYMENT_DETAILS'
export const CLEAR_TAKE_PAYMENT_DETAILS = 'CLEAR_TAKE_PAYMENT_DETAILS'

export const OTHER_TIP_VALUE = 'OTHER';

export const TIP_DATA = [
    {
        id: 't1',
        label: '+ £0',
        // label: '0%',
        value: 0,
    },
    {
        id: 't2',
        label: '+ £1',
        value: 1,
        // label: '10%',
        // value: 0.1,
    },
    {
        id: 't3',
        label: '+ £3',
        value: 3,
        // label: '15%',
        // value: 0.15,
    },
    {
        id: 't4',
        label: '+ £5',
        value: 5,
        // label: '20%',
        // value: 0.2,
    },
    {
        id: 't5',
        label: '+ £10',
        value: 10,
        // label: '50%',
        // value: 0.5,
    },
    {
        id: 't6',
        label: 'Other',
        value: OTHER_TIP_VALUE,
    },
];

export const NOSHOW_PERCENT_OPTIONS = [
    {
        id: 't1',
        label: '0%',
        value: 0,
    },
    {
        id: 't2',
        label: '10%',
        value: 0.1,
    },
    {
        id: 't3',
        label: '15%',
        value: 0.15,
    },
    {
        id: 't4',
        label: '20%',
        value: 0.2,
    },
    {
        id: 't5',
        label: '50%',
        value: 0.5,
    },
    {
        id: 't6',
        label: 'Other',
        value: OTHER_TIP_VALUE,
    },
];

export const PAYMENT_OPTION_ID = {
    NOT_SELECTED: 'NOT_SELECTED',
    SAVED_CARD: 'SAVED_CARD',
    CASH: 2,
    CARD_MACHINE: 1,
    FINANCE: 'FINANCE',
    BANK_TRANSFER: 3,
    ADD_CARD: 'ADD_CARD'
}

export const FEES_BEARER = {
    client: 1,
    business: 0
}

export const TOKEN_TYPE = {
    ryft: 1,
    stripe: 2,
}

export const NO_SHOW_THANKYOU_DESC = {
    amountCharged: 'Appointment is marked as a no-show, we have charge the clients card and sent them an email',
    noCharge: 'Appointment marked as no-show without taking a payment and sent them an email'
}

export const NO_SHOW_THANKYOU_TITLE = {
    amountCharged: 'Payment complete',
    noCharge: 'No payment taken'
}

export const SAVED_CARD_BRAND = {
    mastercard: 'Mastercard',
    visa: 'Visa'
}

export const PAYMENT_BEING_PROCESSED_TEXT="Your payment is being processed and will be reflected in a few moments. "

export const NO_CHARGE_INFO_DATA = {
    NOT_CONNECTED: {
        title: 'Collect payments',
        desc: "Unable to charge no-show payments: You need to connect payments so we can charge your client's card. To avoid this in future, connect payments via payment settings."
    },
    NO_SAVED_CARDS: {
        title: 'Make a payment',
        desc: 'Unable to charge no-show customers: No card details saved because no payment has been made. Please ensure payment is required at booking to save card details. Would you like to proceed marking this appointment as no-show?'
    }
}

export const NO_CHARGE_STATE = {
    NOT_CONNECTED: 'NOT_CONNECTED',
    NO_SAVED_CARDS: 'NO_SAVED_CARDS'
}

export const PAYMENT_MODE = {
    offline: 'offline',
    platform: 'platform',
}